module.exports = __webpack_public_path__ + "static/media/glam-notifications-page.c460371c.jpg";